// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"494":"4e7548b8","789":"9da9f92b"}[chunkId] + ".chunk.css";
};